var map = {
	"./desktop/18-days-voyage.jpg": 3737,
	"./desktop/architecturals.jpg": 9387,
	"./desktop/behind-the-waves.jpg": 1656,
	"./desktop/calm-waters.jpg": 5918,
	"./desktop/cityscapes.jpg": 3595,
	"./desktop/dark-forest.jpg": 3530,
	"./desktop/king-on-africa.jpg": 2854,
	"./desktop/land-of-dreams.jpg": 6742,
	"./desktop/milky-way.jpg": 5181,
	"./desktop/moon-of-appalacia.jpg": 5435,
	"./desktop/mountains.jpg": 161,
	"./desktop/rage-of-the-sea.jpg": 8211,
	"./desktop/running-free.jpg": 2459,
	"./desktop/somwarpet.jpg": 5697,
	"./desktop/trip-to-nowhere.jpg": 4530,
	"./desktop/unforeseen-corners.jpg": 2540,
	"./desktop/world-tour.jpg": 4573,
	"./mobile/18-days-voyage.jpg": 9657,
	"./mobile/architecturals.jpg": 8219,
	"./mobile/behind-the-waves.jpg": 2054,
	"./mobile/calm-waters.jpg": 3454,
	"./mobile/cityscapes.jpg": 7114,
	"./mobile/dark-forest.jpg": 1905,
	"./mobile/king-on-africa.jpg": 9609,
	"./mobile/land-of-dreams.jpg": 9895,
	"./mobile/milky-way.jpg": 1358,
	"./mobile/moon-of-appalacia.jpg": 6420,
	"./mobile/mountains.jpg": 3406,
	"./mobile/rage-of-the-sea.jpg": 190,
	"./mobile/running-free.jpg": 8691,
	"./mobile/somwarpet.jpg": 8811,
	"./mobile/trip-to-nowhere.jpg": 2834,
	"./mobile/unforeseen-corners.jpg": 3803,
	"./mobile/world-tour.jpg": 8437,
	"./read-story-full-mobile": 7377,
	"./read-story-full-mobile.json": 7377,
	"./tablet/moon-of-appalacia.jpg": 1252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3820;